import { render } from "./TableOpenOrders.vue?vue&type=template&id=0639cf6e&scoped=true&ts=true"
import script from "./TableOpenOrders.vue?vue&type=script&lang=ts"
export * from "./TableOpenOrders.vue?vue&type=script&lang=ts"

import "./TableOpenOrders.vue?vue&type=style&index=0&id=0639cf6e&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0639cf6e"]])

export default __exports__